/**
 * Angular Modules
 */
import { CommonModule } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

/**
 * App Root Components
 */
import { DashboardContainerComponent } from './dashboard/dashboard-container/dashboard-container.component';
import { DashboardHeaderComponent } from './dashboard/dashboard-header/dashboard-header.component';
import { FmAppNavigationMenuComponent } from './fannie-mae-cdx-components/fm-app-navigation-menu/fm-app-navigation-menu.component';
import { FmDropdownComponent } from './fannie-mae-cdx-components/fm-dropdown/fm-dropdown.component';
import { FmHeaderComponent } from './fannie-mae-cdx-components/fm-header/fm-header.component';
import { FmInputWithValidationsComponent } from './fannie-mae-cdx-components/fm-input-with-validations/fm-input-with-validations.component';
import { FmLoadingPageComponent } from './fannie-mae-cdx-components/fm-loading-page/fm-loading-page.component';
import { FmMessageAlertsComponent } from './fannie-mae-cdx-components/fm-message-alerts/fm-message-alerts.component';
import { FmToolbarComponent } from './fannie-mae-cdx-components/fm-toolbar/fm-toolbar.component';
import { FeeSchedulesContainerComponent } from './fee-schedules/fee-schedules-container/fee-schedules-container.component';
import { FeeSchedulesComponent } from './fee-schedules/fee-schedules.component';
import { GlobalErrorComponent } from './global-error/global-error.component';

/**
 * App Root Services
 */
import { AuthenticateService } from './shared/services/authenticate.service';
import { FeeScheduleService } from './shared/services/fee-schedule.service';
import { FmLoadingPageService } from './shared/services/fm-loading-page.service';
import { HealthCheckService } from './shared/services/health-check.service';
import { RolesAuthGuardService } from './shared/services/roles-auth-guard.service';
import { SessionTokenizerService } from './shared/services/session-tokenizer.service';
import { SessionService } from './shared/services/session.service';
import { UserService } from './shared/services/user.service';

/**
 * App Root Module
 */
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

/**
 * RCR Feature Module
 */
import { RCRExchangeRoutingModule } from './rcr-exchange/rcr-exchange-routing.module';
import { RCRExchangeModule } from './rcr-exchange/rcr-exchange.module';

/**
 * MEGA Feature Module
 */
import { DashboardModule } from './dashboard/dashboard.module';
import { Error500Component } from './error/error-500/error-500.component';
import { FmCheckboxModule } from './fannie-mae-cdx-components/fm-checkbox/fm-checkbox.module';
import { MegaTradeModule } from './mega-exchange/mega-trade.module';
import { FilterPipe } from './shared/pipes/filter-pipe';
import { CurrenyTransformService } from './shared/services/curreny-transform.service';
import { DownloadPdfService } from './shared/services/download-pdf.service';
import { DownloadXlsxService } from './shared/services/download-xlsx.service';
import { MessageService } from './shared/services/message.service';
import { XlsxToJsonService } from './shared/services/xlsx-to-json.service';

import { NgxPaginationModule } from 'ngx-pagination';
import { FeeDisclaimerService } from './shared/services/fee-disclaimer.service';

@NgModule({
  declarations: [
    AppComponent,
    DashboardContainerComponent,
    DashboardHeaderComponent,
    FmAppNavigationMenuComponent,
    FmHeaderComponent,
    FmDropdownComponent,
    FmLoadingPageComponent,
    FmToolbarComponent,
    FmInputWithValidationsComponent,
    FmMessageAlertsComponent,
    GlobalErrorComponent,
    FeeSchedulesContainerComponent,
    FeeSchedulesComponent,
    Error500Component,
    FilterPipe,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    MegaTradeModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    CoreModule,
    RCRExchangeModule,
    RCRExchangeRoutingModule,
    SharedModule,
    DashboardModule,
    AppRoutingModule,
    FmCheckboxModule.forRoot(),
    NgxPaginationModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  providers: [
    provideHttpClient(),
    FeeScheduleService,
    FmLoadingPageService,
    HealthCheckService,
    RolesAuthGuardService,
    AuthenticateService,
    SessionService,
    UserService,
    SessionTokenizerService,
    MessageService,
    XlsxToJsonService,
    DownloadXlsxService,
    DownloadPdfService,
    FeeDisclaimerService,
    CurrenyTransformService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
